import { CobaltFlagMessage } from '@cae/cobalt-react/components/flag-message';
import {
  CobaltLayout,
  CobaltLayoutContent,
  CobaltLayoutHeader,
  CobaltLayoutSideNavigation,
} from '@cae/cobalt-react/components/layout';
import { AppHeader } from '@layouts/components/app-header/AppHeader';
import { useQualtricsInitializer } from '@shared/hooks/use-qualtrics-initializer/useQualtricsInitializer';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { AppSideNavigation } from '../app-side-navigation/AppSideNavigation';

/**
 * Inner shell rendered only after permissions and modules are loaded.
 * Keeps useQualtricsInitializer behind the loading/error gates in AppLayout.
 */
const AppShell = React.memo((): React.ReactElement => {
  useQualtricsInitializer();

  return (
    <>
      <CobaltFlagMessage />
      <CobaltLayout>
        <CobaltLayoutHeader>
          <AppHeader hasSideNavigation={true} />
        </CobaltLayoutHeader>

        <CobaltLayoutSideNavigation>
          <AppSideNavigation />
        </CobaltLayoutSideNavigation>

        <CobaltLayoutContent>
          <Outlet />
        </CobaltLayoutContent>
      </CobaltLayout>
    </>
  );
});

AppShell.displayName = 'AppShell';

export { AppShell };
